// extracted by mini-css-extract-plugin
export default {"contain":"Services_contain__L2nQ6","cont":"Services_cont__0Kxr+","heading":"Services_heading__ktpfA","subHeading":"Services_subHeading__g-cz6"};